class AJXDialog {
  constructor(element, onClose) {
    this.element = element;
    this.onClose = onClose;
    element.setAttribute('role', 'dialog');
    element.setAttribute('aria-modal', 'true');
    element.setAttribute('aria-hidden', 'true');
    element.inert = true;
    element.addEventListener('keydown', (event) => {
      if (!this.opened) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      } else if (event.key === 'Tab') {
        const items = this.focusable();
        const first = items[0];
        const last = items[items.length - 1];
        if (!first) { event.preventDefault(); element.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) {
          event.preventDefault(); first.focus();
        }
      }
    });
  }
  focusable() {
    return Array.from(this.element.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter(el => !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  }
  open(opener, focusTarget) {
    if (this.opened) return;
    this.opened = true;
    this.opener = opener || document.activeElement;
    document.body.appendChild(this.element);
    this.previousOverflow = document.body.style.overflow;
    this.background = Array.from(document.body.children).filter(el => el !== this.element).map(el => [el, el.inert]);
    this.background.forEach(([el]) => { el.inert = true; });
    this.element.inert = false;
    this.element.setAttribute('aria-hidden', 'false');
    this.element.classList.add('active');
    document.body.style.overflow = 'hidden';
    (focusTarget || this.focusable()[0] || this.element).focus();
  }
  close() {
    if (!this.opened) return;
    this.opened = false;
    this.element.classList.remove('active');
    this.element.inert = true;
    this.element.setAttribute('aria-hidden', 'true');
    this.background.forEach(([el, inert]) => { el.inert = inert; });
    document.body.style.overflow = this.previousOverflow;
    if (this.opener?.isConnected && this.opener.getClientRects().length) this.opener.focus();
    this.onClose?.();
  }
}
window.AJXDialog = AJXDialog;
